import { createRoutine } from 'redux-saga-routines';

// TODO this shall be removed once we move 2FA verify token call to BE
export const invalidateUsersList = createRoutine('INVALIDATE_USERS_LIST');

export const fetchUserEmailSignature = createRoutine(
  'FETCH_USER_EMAIL_SIGNATURE'
);
export const createUserEmailSignature = createRoutine(
  'CREATE_USER_EMAIL_SIGNATURE'
);
export const updateUserEmailSignature = createRoutine(
  'UPDATE_USER_EMAIL_SIGNATURE'
);
export const deleteUserEmailSignature = createRoutine(
  'DELETE_USER_EMAIL_SIGNATURE'
);
